import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { FormControl } from '@mui/material';

import { ModalButtonRow } from '../ModalButtonRow';

import {
  TEXT,
  FULL_WIDTH,
  DOUBLE_FIELDS_WRAPPER,
  SINGLE_FIELD_WRAPPER,
} from '../../../constants/Dashboard';

import {
  EMPLOYMENT_MODAL,
  JOB_DURATION_LABEL,
  SALARY_ATTRIBUTES,
  TOTAL_INCOME,
} from '../../../constants/Dashboard/Employment';

import { getTotalIncome, getFieldType } from '../../../utils';

import './EmploymentModalContent.css';

export const EmploymentModalContent = ({ handleClose, onConfirm, employmentInfo, user }) => {
  const [employmentModalInfoState, setEmploymentModalInfoState] = useState(employmentInfo);

  return (
    <>
      <div className="employment-modal-content-wrapper">
        {EMPLOYMENT_MODAL.rows.map((row) => {
          return (
            <div
              key={row.map((column) => column.label).join('')}
              className="employment-modal-row-content"
            >
              {row.map((column) => {
                const element = getFieldType({
                  type: column.fieldType,
                  options: column?.options || [],
                  value:
                    column.label === JOB_DURATION_LABEL
                      ? employmentModalInfoState[column.label][column.placeholder]
                      : employmentModalInfoState[column.label],
                  fieldEnumType: column.type || TEXT,
                  textContent: column.text,
                  incomeAmt: employmentModalInfoState[TOTAL_INCOME],
                  onChange: (e) => {
                    setEmploymentModalInfoState((prevState) => {
                      let updatedState = prevState;

                      if (column.label === JOB_DURATION_LABEL) {
                        updatedState = {
                          ...prevState,
                          [column.label]: {
                            ...prevState[column.label],
                            [column.placeholder]: e.target.value,
                          },
                        };
                      } else if (SALARY_ATTRIBUTES.includes(column.label)) {
                        const otherTwo = SALARY_ATTRIBUTES.filter((att) => att !== column.label);
                        updatedState = {
                          ...prevState,
                          [column.label]: e.target.value,
                          [TOTAL_INCOME]: getTotalIncome(
                            prevState[otherTwo[0]] || 0,
                            prevState[otherTwo[1]] || 0,
                            Number(e.target.value),
                          ),
                        };
                      } else {
                        updatedState = {
                          ...prevState,
                          [column.label]: e.target.value,
                        };
                      }

                      mixpanel.track('Employment Modal', {
                        user_id: user.id,
                        distinct_id: user.id,
                        employment_modal_state: updatedState,
                        field: column.label,
                      });

                      return updatedState;
                    });
                  },
                });
                const fullWidthOnMobile = column.fullWidthOnMobile ? FULL_WIDTH : '';
                const fieldWrappClass =
                  row.length > 1 ? DOUBLE_FIELDS_WRAPPER : SINGLE_FIELD_WRAPPER;
                return (
                  // clx css eventually
                  <div
                    key={column.label + ' ' + column.placeholder}
                    className={fieldWrappClass + ' ' + fullWidthOnMobile}
                  >
                    {column.label && (
                      <p className="employment-field-label" style={{ ...column?.style }}>
                        {column.label}
                      </p>
                    )}
                    <FormControl sx={{ width: `100%`, pl: 0.5 }}>{element}</FormControl>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <ModalButtonRow
        onCancel={handleClose}
        onConfirm={() => onConfirm({ employmentInfo: employmentModalInfoState })}
        valid={true}
      />
    </>
  );
};
